
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */
export function isString (value) {
    return typeof value === 'string'
}

export function isArray(value) {
    return Array.isArray(value);
}

export function isNodeList(value) {
    return NodeList.prototype.isPrototypeOf(value);
}
